import React, { Fragment, useEffect, useState } from "react";
import "./App.css";
import Header from "./components/Header";
import Intro from "./components/Intro";
import About from "./components/About";
import Work from "./components/Work";
import Contact from "./components/Contact";
import SideBars from "./components/SideBars";
import { useDoubleTap } from "use-double-tap";

function App() {
  const [color, setColor] = useState(false);

  const bind = useDoubleTap((event) => {
    setColor((prev) => !prev);
  });

  useEffect(() => {
    console.log("Double tapped", color);
    document.body.style.backgroundColor = color ? "#003049" : "#0c3db0";
    document.getElementById("Header").style.backgroundColor = color
      ? "#003049"
      : "#0c3db0";
  }, [color]);
  return (
    <Fragment>
      <div {...bind}>
        <Header />
        <Intro />
        <About />
        <Work />
        <Contact />
        <SideBars />
      </div>
    </Fragment>
  );
}

export default App;
